export default __webpack_public_path__ + "static/media/aboutwavebtm.ddee30f1.png";